import type { User } from '../../types'
import { ALEX_PARTICIPANT_ID } from './types'

export const ALEX_SUPPORT_WORKER_IDS = ['u-jess', 'u-priya', 'u-dan'] as const
export const LILLIAN_USER_ID = 'u-lillian'
export const MARK_USER_ID = 'u-mark'

export type CareMenuCapability = 'assign_menu' | 'manage_templates' | 'manage_notes' | 'check_preparation'

export function canAccessCareMenu(user: Pick<User, 'id'>) {
  return user.id === ALEX_PARTICIPANT_ID || user.id === LILLIAN_USER_ID || user.id === MARK_USER_ID || ALEX_SUPPORT_WORKER_IDS.includes(user.id as typeof ALEX_SUPPORT_WORKER_IDS[number])
}

export function canUseCareMenu(user: Pick<User, 'id'>, capability: CareMenuCapability) {
  if (!canAccessCareMenu(user)) return false
  if (capability === 'assign_menu') return user.id === ALEX_PARTICIPANT_ID || user.id === LILLIAN_USER_ID || user.id === MARK_USER_ID
  if (capability === 'manage_templates' || capability === 'manage_notes') return user.id === LILLIAN_USER_ID || user.id === MARK_USER_ID
  return true
}

export function careMenuParticipantId(user: Pick<User, 'id'>) {
  if (user.id === LILLIAN_USER_ID) return LILLIAN_USER_ID
  return canAccessCareMenu(user) ? ALEX_PARTICIPANT_ID : null
}

